import { EmployeeTitleHelper } from "@/Common/Helpers/EmployeeTitleHelper";
import { EmployeeTitle } from "@/Common/Models/Employee/Enums/EmployeeTitle";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";

enum CareProviderRole {
    Other = "Other",
    Doctor = "MD",
    RegisteredMidwife = "RM",
    NursePractitioner = "NP"
}

class CareProviderRoleHelper {
    public static getCareProviderRoleByEmployee(careProvider: EmployeeUIModel): CareProviderRole {
        const title = careProvider.getIssuingOrgRule()?.Title;

        if (EmployeeTitleHelper.isDoctor(title))
            return CareProviderRole.Doctor;

        if (title === EmployeeTitle.NursePractitioner)
            return CareProviderRole.NursePractitioner;

        if (title === EmployeeTitle.Midwife)
            return CareProviderRole.RegisteredMidwife;

        return CareProviderRole.Other;
    }
}

export { CareProviderRole, CareProviderRoleHelper };
